import Select, { StylesConfig } from "react-select";
import React, { useState, useEffect, useRef } from "react";
// import '../assets/css/cstm-select.css';
import FeatherIcon from "feather-icons-react";
import "../../assets/css/cstm-select.css";
import "../../assets/css/form.css";

function MultipleSelectDropdown(props) {
  const {
    name,
    id,
    options,
    fieldClass,
    containerStyle,
    defaultselect,
    searchFields,
    placeholder,
    isRequired = 1,
    customLabel,
    errId,
    caseCheckId,
    checkDetailsIndex,
    fieldName,
    emtpyOption,
    listType,
    handleMultiSelect,
    handleMoreFilters,
    reset,
    styles,
    searchFlag,
    menuStyle,
    value,
    fieldId,
    isDisabled
  } = props;
  const [initiateValue, setInitiateValue] = useState("");

  document.body.style.overflow = "scroll";

  console.log("aa", options);

  const tpDropdown = useRef();

  useEffect(() => {
    return () => {
        // removing all preselected checks
        let checkbox = document.getElementsByClassName(`digilockerDoc-checkbox-${checkDetailsIndex}`);
        for (let i = 0; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          } 
    }
  },[])

  useEffect(() => {
    if (listType == "caseSeverity") {
      if (defaultselect !== "") {
        let val = defaultselect?.join(", ");
        setSelectedValue(val);
      } else {
        setSelectedValue(defaultselect);
      }
    } else if (listType == "caseStatus") {
      if (defaultselect !== "") {
        let val = defaultselect?.join(", ");
        setSelectedValue(val);
      } else {
        setSelectedValue(defaultselect);
      }
    } else if (listType == "checkStatus") {
      if (defaultselect !== "") {
        let val = defaultselect?.join(", ");
        setSelectedValue(val);
      } else {
        setSelectedValue(defaultselect);
      }
    } else if (listType == "checkSeverity") {
      if (defaultselect !== "") {
        let val = defaultselect?.join(", ");
        setSelectedValue(val);
      } else {
        setSelectedValue(defaultselect);
      }
    } else if (listType == "digilockerDoc") {
      handlePreSelected();
      if (defaultselect !== "") {
        let val = defaultselect?.join(", ");
        setSelectedValue(val);
      } else {
        setSelectedValue(defaultselect);
      }
    }
  }, [defaultselect]);

  //   let flag = false;
  //   useEffect(() => {
  //     if (searchFlag === true) {
  //       flag = true;
  //     }
  //   }, [])

  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [clickedOutside, setClickedOutside] = useState(false);
  const [noResults, setNoResults] = useState(true);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState([]);
  const [allFilterOptions, setallFilterOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const myRef = useRef();
  const myRef1 = useRef();

  useEffect(() => {
    if (listType == "caseSeverity") {
      // setSelectedValue(defaultselect[0]);
      let checkbox = document.getElementsByClassName("caseSeverity-checkbox");
      for (let i = 0; i < checkbox.length; i++) {
        // if(defaultselect.includes(checkbox[i].nextSibling.attributes[0].value)){
        if (defaultselect?.includes(checkbox[i].nextSibling.outerText)) {
          checkbox[i].checked = true;
        }
      }
    } else if (listType == "caseStatus") {
      // setSelectedValue(defaultselect[0]);
      let checkbox = document.getElementsByClassName("caseStatus-checkbox");
      for (let i = 0; i < checkbox.length; i++) {
        if (
          defaultselect &&
          defaultselect?.includes(checkbox[i].nextSibling.outerText)
        ) {
          checkbox[i].checked = true;
        }
      }
    } else if (listType == "checkStatus") {
      // setSelectedValue(defaultselect[0]);
      let checkbox = document.getElementsByClassName("checkStatus-checkbox");
      for (let i = 0; i < checkbox.length; i++) {
        if (
          defaultselect &&
          defaultselect?.includes(checkbox[i].nextSibling.outerText)
        ) {
          checkbox[i].checked = true;
        }
      }
    } else if (listType == "checkSeverity") {
      // setSelectedValue(defaultselect[0]);
      let checkbox = document.getElementsByClassName("checkSeverity-checkbox");
      for (let i = 0; i < checkbox.length; i++) {
        if (
          defaultselect &&
          defaultselect?.includes(checkbox[i].nextSibling.outerText)
        ) {
          checkbox[i].checked = true;
        }
      }
    } else if (listType == "digilockerDoc") {
      // setSelectedValue(defaultselect[0]);
      let checkbox = document.getElementsByClassName(`digilockerDoc-checkbox-${checkDetailsIndex}`);
      for (let i = 0; i < checkbox.length; i++) {
        if (
          defaultselect &&
          defaultselect?.includes(checkbox[i].nextSibling.outerText)
        ) {
          checkbox[i].checked = true;
        }
      }
    }
  }, [allOptions]);

  const handleDropdownClick = (e) => {
    // e.preventDefault();
    e.stopPropagation();
    if(isDisabled){
      return;
    }
    if(listType == 'digilockerDoc'){
      let checkbox = document.getElementsByClassName(`digilockerDoc-checkbox-${checkDetailsIndex}`);
      for (let i = 0; i < checkbox.length; i++) {
        if (
          defaultselect &&
          defaultselect?.includes(checkbox[i].nextSibling.outerText)
        ) {
          checkbox[i].checked = true;
        }else{
          checkbox[i].checked = false;
        }
      }
    }
    document.body.style.overflow = "hidden";
    setClickedOutside(true);
    setOpen((prevState) => !prevState);
    if (listType === "filters" && open === false) {
      setallFilterOptions(options);
      // handleMoreFilters(allFilterOptions);
      // handleMoreFilters(allFilterOptions , selectedFilters);
    }
    // if(listType === 'filters'){

    // }
  };
  const selectedList = [];
  const handleSelectValue = (value, e) => {
    // console.log(myRef);
    if (value) {
      if (listType === "caseSeverity") {
        let caseSeverityList = [];
        let selectAll = false;
        let checkbox = document.getElementsByClassName("caseSeverity-checkbox");
        if (
          checkbox[0].checked == true &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = true;
        }
        if (
          checkbox[0].checked == false &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = false;
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          }
        }
        if (selectAll == true) {
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = true;
            // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            caseSeverityList.push(checkbox[i].nextSibling.outerText);
          }
          // caseSeverityList.push( "Discrepant",
          // "Minor Discrepant",
          // "Attention Required",
          // "Insufficient",
          // "No Response Received",
          // "Submission Done - Completed",
          // "Clear"
          // )
        } else {
          if (
            checkbox[0].checked == true &&
            checkbox[0].nextSibling.outerText === "Select all"
          ) {
            checkbox[0].checked = false;
          }
          for (let i in checkbox) {
            if (
              checkbox[i].checked == true &&
              checkbox[i].nextSibling.attributes[1].value !== "Select all"
            ) {
              caseSeverityList.push(checkbox[i].nextSibling.outerText);
              // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            }
          }
          console.log(caseSeverityList);
        }
        let selVal = "";
        if (caseSeverityList && caseSeverityList[0]) {
          selVal = caseSeverityList.join(", ");
        }
        setSelectedValue(selVal);

        handleMultiSelect(
          { id: value, value: value, list: caseSeverityList },
          listType
        );
      }

      if (listType === "caseStatus") {
        let caseStausList = [];
        let caseStausIdList = [];

        let selectAll = false;
        let checkbox = document.getElementsByClassName("caseStatus-checkbox");

        if (
          checkbox[0].checked == true &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = true;
        }
        if (
          checkbox[0].checked == false &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = false;
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          }
        }

        console.log("xcx", selectAll);
        if (selectAll == true) {
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = true;

            caseStausList.push(checkbox[i].nextSibling.outerText);
          }
        } else {
          if (
            checkbox[0].checked == true &&
            checkbox[0].nextSibling.outerText === "Select all"
          ) {
            checkbox[0].checked = false;
          }
          for (let i in checkbox) {
            if (
              checkbox[i].checked == true &&
              checkbox[i].nextSibling.attributes[1].value !== "Select all"
            ) {
              caseStausList.push(checkbox[i].nextSibling.outerText);
              caseStausIdList.push(checkbox[i].attributes[3].value);
            }
          }
          console.log(caseStausList);
        }
        let selVal = "";
        if (caseStausList && caseStausList[0]) {
          selVal = caseStausList.join(", ");
        }
        setSelectedValue(selVal);

        handleMultiSelect(
          {
            id: value,
            value: value,
            list: caseStausList,
            ids: caseStausIdList,
          },
          listType
        );
      }

      if (listType === "checkStatus") {
        let checkStatusList = [];
        let checkStatusIDList = [];

        let selectAll = false;
        let checkbox = document.getElementsByClassName("checkStatus-checkbox");

        if (
          checkbox[0].checked == true &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = true;
        }
        if (
          checkbox[0].checked == false &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = false;
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          }
        }

        console.log("xcx", selectAll);
        if (selectAll == true) {
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = true;

            checkStatusList.push(checkbox[i].nextSibling.outerText);
          }
        } else {
          if (
            checkbox[0].checked == true &&
            checkbox[0].nextSibling.outerText === "Select all"
          ) {
            checkbox[0].checked = false;
          }
          for (let i in checkbox) {
            if (
              checkbox[i].checked == true &&
              checkbox[i].nextSibling.attributes[1].value !== "Select all"
            ) {
              checkStatusList.push(checkbox[i].nextSibling.outerText);
              checkStatusIDList.push(checkbox[i].attributes[3].value);
            }
          }
          console.log(checkStatusList);
        }
        let selVal = "";
        if (checkStatusList && checkStatusList[0]) {
          selVal = checkStatusList.join(", ");
        }
        setSelectedValue(selVal);

        handleMultiSelect(
          {
            id: value,
            value: value,
            list: checkStatusList,
            ids: checkStatusIDList,
          },
          listType
        );
      }

      if (listType === "checkSeverity") {
        // let caseSeverityList = [];
        let checkSeverityList = [];
        let selectAll = false;
        let checkbox = document.getElementsByClassName(
          "checkSeverity-checkbox"
        );
        if (
          checkbox[0].checked == true &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = true;
        }
        if (
          checkbox[0].checked == false &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = false;
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          }
        }
        if (selectAll == true) {
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = true;
            // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            checkSeverityList.push(checkbox[i].nextSibling.outerText);
          }
          // caseSeverityList.push( "Discrepant",
          // "Minor Discrepant",
          // "Attention Required",
          // "Insufficient",
          // "No Response Received",
          // "Submission Done - Completed",
          // "Clear"
          // )
        } else {
          if (
            checkbox[0].checked == true &&
            checkbox[0].nextSibling.outerText === "Select all"
          ) {
            checkbox[0].checked = false;
          }
          for (let i in checkbox) {
            if (
              checkbox[i].checked == true &&
              checkbox[i].nextSibling.attributes[1].value !== "Select all"
            ) {
              checkSeverityList.push(checkbox[i].nextSibling.outerText);
              // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            }
          }
          console.log(checkSeverityList);
        }
        let selVal = "";
        if (checkSeverityList && checkSeverityList[0]) {
          selVal = checkSeverityList.join(", ");
        }
        setSelectedValue(selVal);

        handleMultiSelect(
          { id: value, value: value, list: checkSeverityList },
          listType
        );
      }

      if (listType === "digilockerDoc") {
        if(e.label == 'Degree/ Diploma Certificate'){
          return;
        }
        // let digilockerDocList = defaultselect.length > 0 ? defaultselect : [];
        let digilockerDocList = []
        let valueList = [];
        let selectAll = false;
        let checkbox = document.getElementsByClassName(
          `digilockerDoc-checkbox-${checkDetailsIndex}`
        );
        if (
          checkbox[0].checked == true &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = true;
        }
        if (
          checkbox[0].checked == false &&
          checkbox[0].nextSibling.outerText === "Select all" &&
          value?.currentTarget?.innerText === "Select all"
        ) {
          selectAll = false;
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = false;
          }
        }
        if (selectAll == true) {
          for (let i = 1; i < checkbox.length; i++) {
            checkbox[i].checked = true;
            // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            digilockerDocList.push(checkbox[i].nextSibling.outerText);
          }
        } else {
          if (
            checkbox[0].checked == true &&
            checkbox[0].nextSibling.outerText === "Select all"
          ) {
            checkbox[0].checked = false;
          }
          for (let i in checkbox) {
            if (
              checkbox[i].checked == true &&
              checkbox[i].nextSibling.attributes[1].value !== "Select all"
            ) {
              digilockerDocList.push(checkbox[i].nextSibling.outerText);
              // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
            }
          }
          console.log(digilockerDocList);
        }
        let selVal = "";
        if (digilockerDocList && digilockerDocList[0]) {
          selVal = digilockerDocList.join(", ");
          options[0]?.map((data) => {
            if(digilockerDocList.includes(data?.label)){
                valueList.push(data?.value?.doc_type);
            }
          })
        }
        setSelectedValue(selVal);
        // handlePreSelected();
        console.log(e)
        handleMultiSelect(
          { id: value, value: value, list: digilockerDocList, 
            data: [{
                name: name,
                value: e,
                fieldId: fieldId,
                isRequired: isRequired,
                err_id: errId,
                caseCheckId: caseCheckId,
                checkdetailsindex: checkDetailsIndex,
                fieldname: fieldName,
                valueList: valueList
              } ]},
          listType, 
        );
        // props.selectOption([
        //   {
        //     name: name,
        //     value: value,
        //     fieldId: fieldId,
        //     isRequired: isRequired,
        //     err_id: errId,
        //     caseCheckId: caseCheckId,
        //     checkdetailsindex: checkDetailsIndex,
        //     fieldname: fieldName,
        //   },
        // ]);
      }
    }
  };

  useEffect(() => {
    let obj = [];
    if (listType === "package") {
      let newObj = options[0];
      console.log(newObj);
      obj = Object.values(newObj);
      if (obj.length === 0) {
        setNoResults(true);
      } else {
        console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(obj);
    }

    if (listType === "filters") {
      if (options.length === 0) {
        setNoResults(true);
      } else {
        console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options);
    }
    if (listType === "caseSeverity") {
      if (options[0].length === 0) {
        setNoResults(true);
      } else {
        // console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options[0]);
    }

    if (listType === "caseStatus") {
      if (options[0].length === 0) {
        setNoResults(true);
      } else {
        // console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options[0]);
    }

    if (listType === "checkStatus") {
      if (options[0].length === 0) {
        setNoResults(true);
      } else {
        // console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options[0]);
    }

    if (listType === "checkSeverity") {
      if (options[0].length === 0) {
        setNoResults(true);
      } else {
        // console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options[0]);
    }

    if (listType === "digilockerDoc") {
      if (options && options?.[0]?.length === 0) {
        setNoResults(true);
      } else {
        // console.log(obj[0]);
        setNoResults(false);
      }
      setAllOptions(options[0]);
    }
  }, [options]);
  

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [myRef]);

  //   useEffect(() => {
  //     document.addEventListener("mousedown", handleClickOutside);
  //     return () => document.removeEventListener("mousedown", handleClickOutside);
  //   }, [myRef1]);

  const handleClickOutside = (e) => {
    if (!myRef.current.contains(e.target)) {
      setClickedOutside(true);
      setOpen(false);
    }
    // if (!myRef1.current.contains(e.target)) {
    //     setClickedOutside(true);
    //     setOpen(false);
    //   }
  };
  const handlePreSelected = () => {
    let checkbox = document.getElementsByClassName(`digilockerDoc-checkbox-${checkDetailsIndex}`);
    for (let i = 0; i < checkbox.length; i++) {
      if (
        checkbox[i].nextSibling.outerText == "Degree/ Diploma Certificate" 
        // ||
        // checkbox[i].nextSibling.outerText.includes("certificate")
      ) {
        checkbox[i].checked = true;
      }
      // caseSeverityList.push(checkbox[i].nextSibling.attributes[1].value);
      // digilockerDocList.push(checkbox[i].nextSibling.outerText);
    }
  };
  return (
    <>
      {/* // onClick={(e) => handleDropdownClick(e)}  */}
      {/* <div className="floating-label tp-dropdown" ref={tpDropdown} /> */}
      {/* <label htmlFor={id} className={'focused'}>{placeholder} {isRequired == 1 && <sup className="text-danger">*</sup>}</label> */}
      <div
        // className='d-none'
        ref={myRef}
        class={`cstm-select-box focused ${open ? "open" : ""}`}
        onClick={(e) => {
          handleDropdownClick(e);
          // handleMoreFilters(e,)
        }}
        style={{ width: "100%", borderRadius: 12 }}
        //   >
      >
        {/* {placeholder} */}

          {/* Label starts here */}
          <label
            htmlFor={id}
            className={`floating-label ${selectedValue ? 'focused' : ''}`}
            style={{
              position: "relative",
              top: "20px",
              left: "17px",
              fontSize: '.85rem',
              background: "white",
              borderRadius: "8px",
              padding: "2px"
            }}
            onClick={(e) => {
              // Handle label click to focus the input
              e.preventDefault();
              const inputField = document.getElementById(id);
              if (inputField) {
                inputField.focus();
              }
            }}
          >
            {customLabel} {isRequired == 1 && <sup className="text-danger">*</sup>}
          </label>
          {/* Label ends here */}

        <div
          class={`select`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "10px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            height: "47px",
            backgroundColor: `${isDisabled ? "#e9ecef" : 'white'}`
          }}
          
        >
          <span
            class="ml-1"
            style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          >
            {selectedValue || "Select"}
            {/* {selectedValue || customPlaceHolder != '' ? 'Select option' : "Select"} */}
          </span>
          <FeatherIcon
            // style={{ color: '#1570EF' }}
            icon="chevron-down"
            style={{ display: "flex", position: "static" }}
          />
        </div>

        {/* // style={{ top: '40px', width: '100%', overflowY: 'auto', overflowX: 'hidden' }} */}
        <ul
          class="options"
          style={{ top: "auto", ...menuStyle }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* {listType === "caseStatus" && (noResults === false) && allOptions &&
              <div className='d-flex' style={{ alignItems: 'center', paddingLeft: 10, width: '100%' }} onClick={(e) => handleSelectValue(e)} >
                <input className={`multi-checkbox caseSeverity-checkbox`} type='checkbox'
                  checked={allOptions && searchFields && allOptions?.length === searchFields?.byStatus?.length ? true : false}
                  id='case-status'
                />
                <li
                  for={`case-status`} style={{ width: '100%' }}
                  //   class={(option[0] === selectedValue) ? 'selected' : ''}

                  value={'Select all'}
                  data-index={"Select all"}
                // onClick={(e) => handleSelectValue(option[1])}
                >
                  <label for={`case-status`} style={{ width: '100%' }}>
                    {'Select all'}
                  </label>
                </li>
              </div>
            } */}

          {listType === "caseStatus" &&
            noResults === false &&
            allOptions &&
            Object.entries(allOptions).map((option, t) => {
              return (
                <div
                  for={`check-${t}`}
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    width: "100%",
                  }}
                  onClick={(e) => handleSelectValue(e)}
                >
                  <input
                    className="multi-checkbox caseStatus-checkbox"
                    type="checkbox"
                    id={`check-${t}`}
                    data-actualid={option[0]}
                  />
                  {/* <li for={`check-${t}`} style={{ width: '100%' }}


                      // value= {option}
                      // data-index={t}

                    > */}
                  {/* <li></li> */}
                  <label
                    for={`check-${t}`}
                    style={{ width: "100%", marginBottom: 0 }}
                  >
                    <li style={{ padding: "5px,5px,5px,10px" }}>{option[1]}</li>
                  </label>
                  {/* </li> */}
                </div>
              );
            })}

          {listType === "caseSeverity" &&
            noResults === false &&
            allOptions &&
            Object.values(allOptions).map((option, t) => {
              return (
                <div
                  for={`sevcheck-${t}`}
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    width: "100%",
                  }}
                  onClick={(e) => handleSelectValue(e)}
                >
                  <input
                    className="multi-checkbox caseSeverity-checkbox"
                    type="checkbox"
                    id={`sevcheck-${t}`}
                  />
                  {/* <li for={`sevcheck-${t}`} style={{ width: '100%' }}


                      value= {option.ID}
                      data-index={t}

                    > */}
                  <label
                    for={`sevcheck-${t}`}
                    style={{ width: "100%", marginBottom: 0 }}
                  >
                    <li style={{ padding: "5px,5px,5px,10px" }}>
                      {option.label}
                    </li>
                  </label>
                  {/* </li> */}
                </div>
              );
            })}

          {listType === "checkSeverity" &&
            noResults === false &&
            allOptions &&
            Object.values(allOptions).map((option, t) => {
              return (
                <div
                  for={`sevcheck-${t}`}
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    width: "100%",
                  }}
                  onClick={(e) => handleSelectValue(e)}
                >
                  <input
                    className="multi-checkbox checkSeverity-checkbox"
                    type="checkbox"
                    id={`sevcheck-${t}`}
                  />
                  {/* <li for={`sevcheck-${t}`} style={{ width: '100%' }}


                      value= {option.ID}
                      data-index={t}

                    > */}
                  <label
                    for={`sevcheck-${t}`}
                    style={{ width: "100%", marginBottom: 0 }}
                  >
                    <li style={{ padding: "5px,5px,5px,10px" }}>
                      {option.SEVERITY_CATEGORY}
                    </li>
                  </label>
                  {/* </li> */}
                </div>
              );
            })}

          {listType === "checkStatus" &&
            noResults === false &&
            allOptions &&
            Object.entries(allOptions).map((option, t) => {
              return (
                <div
                  for={`check-${t}`}
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    width: "100%",
                  }}
                  onClick={(e) => handleSelectValue(e)}
                >
                  <input
                    className="multi-checkbox checkStatus-checkbox"
                    type="checkbox"
                    id={`check-${t}`}
                    data-actualid={option[0]}
                  />
                  {/* <li></li> */}
                  <label
                    for={`check-${t}`}
                    style={{ width: "100%", marginBottom: 0 }}
                  >
                    <li style={{ padding: "5px,5px,5px,10px" }}>{option[1]}</li>
                  </label>
                  {/* </li> */}
                </div>
              );
            })}

          {listType === "digilockerDoc" &&
            noResults === false &&
            allOptions &&
            Object.values(allOptions).map((option, t) => {
              return (
                <div
                  key={`digicheck-${checkDetailsIndex}-${t}`}
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    width: "100%",
                  }}
                >
                  <input
                    className={`multi-checkbox digilockerDoc-checkbox-${checkDetailsIndex}`}
                    type="checkbox"
                    disabled={option?.label == 'Degree/ Diploma Certificate' ? true : false}
                    // checked={option.label == 'Degree/ Diploma Certificate' ? true : checked }
                    id={`digicheck-${checkDetailsIndex}-${t}`}
                    onClick={(e) => {
                      // e.preventDefault(); // Prevent event from bubbling up
                      handleSelectValue(e, option);
                      }}
                  />
                  <label
                    for={`digicheck-${checkDetailsIndex}-${t}`}
                    style={{ width: "100%", marginBottom: 0 }}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent event from bubbling up
                      if(e.currentTarget.previousSibling.checked == true){
                        e.currentTarget.previousSibling.checked = false
                      }else{
                        e.currentTarget.previousSibling.checked = true
                      }
                      handleSelectValue(e, option);
                      }}
                  >
                    <li style={{ padding: "5px,5px,5px,10px" }}>
                      {option.label}
                    </li>
                  </label>
                  {/* </li> */}
                </div>
              );
            })}
        </ul>
        {/* <label className="floating-label focused">{placeholder}</label> */}
      </div>


    </>
  );
}

export default MultipleSelectDropdown;
